export const BASE_URL = "https://backend.skt.fi";
//export const BASE_URL = "";

export const API_ENDPOINTS = {
  postalCodes: {
    both: "/skt/postal-codes-FI-SE.json",
    fi: "/skt/postal-codes-FI.json",
  },
  userInfo: "/skt/userinfo",
  order: {
    status: (secret) => `/skt/order_${secret}.json`,
    paymentRedirect: (secret) => `/skt/payment_redirect/${secret}`,
    bnplRedirect: (secret) => `/skt/bnpl/redirect/${secret}`,
    confirmBilling: (secret) => `/skt/billing.json/${secret}/confirm`,
    trackShipment: (secret) => `/skt/s/${secret}`,
    waybill: (secret) => `/skt/pdf/waybill-${secret}.pdf`,
    label: (secret) => `/skt/pdf/label-${secret}.pdf`,
    invoice: (secret) => `/skt/pdf/invoice-${secret}.pdf`,
    cancel: (secret) => `/skt/order_cancel.json/${secret}`,
    setTrack: (secret) => `/skt/v1/order/track_${secret}.json`,
    getTrack: (secret) => `/skt/v1/order/ga_${secret}.json`,
    sendTracking: (secret) => `/skt/v1/order/send_tracking_${secret}.json`,
  },

  priceQuery: {
    cars: "/skt/cars.query",
    machinery: "/skt/mach.query",
    parcel: "/skt/query",
  },

  orderCreation: {
    parcel: "/skt/order",
    cars: "/skt/cars.order",
    machinery: "/skt/mach.order",
  },

  auth: {
    login: "/skt/apilogin/",
    logout: "/skt/logout/",

    createAccount: "/skt/register/submit.json",
    requestPasswordReset: "/skt/passforgot.json",
    activateAccount: (key) => `/skt/act.json/${key}`,
  },

  profile: {
    account: "/skt/profile.json/",
    orders: "/skt/profile.json/orders",
    save: "/skt/profile.json/save",
    changePassword: "/skt/profile.json/set_password",
    favorites: "/skt/profile/favorites.json",
  },

  admin: {
    customers: "/skt/yllapito/customers.json",
    orders: "/skt/yllapito/orders.json",
  },

  damageClaim: "/skt/damage-claim",
};
